<template>
	<div>
		<h6 class="headline pa-2 mb-3 text-center">
			Dstr Signature Verification
		</h6>
		<v-card
			class="white--text pa-2 d-flex justify-space-between align-center body-2 full-width text-center"
			ripple
			:color="themeInputColor"
		>
			<div style="width: 50%">Name/UserId</div>
			<div style="width: 50%">City/State</div>
		</v-card>
		<v-card
			v-if="!nonVerifiedSignatures.length"
			class="text-center pa-4 body-2"
			:loading="true"
		>
			<div>No pending signatures for verification</div>
		</v-card>
		<v-card
			v-for="{
				retailerName = '-',
				city = '-',
				state = '-',
				userId,
				signatureId
			} in nonVerifiedSignatures"
			:key="signatureId"
			class="pa-2"
		>
			<div class="d-flex justify-space-between align-center full-width">
				<div style="width: 50%">
					<div class="title">{{ retailerName }}</div>
					<div class="caption">{{ userId }}</div>
				</div>
				<div class="text-center" style="width: 50%">
					<div class="body-2">{{ city }}</div>
					<div>{{ state }}</div>
				</div>
			</div>
		</v-card>
	</div>
</template>

<script>
import { GET_NON_VERIFIED_SIGNATURE } from "../../store/action-types";
import { THEME_INPUT_COLOUR } from "../constants";

export default {
	data() {
		return {
			nonVerifiedSignatures: [],
			themeInputColor: THEME_INPUT_COLOUR
		};
	},
	mounted() {
		this.fetchNonVerifiedSignatures();
	},
	methods: {
		fetchNonVerifiedSignatures() {
			this.$store
				.dispatch(GET_NON_VERIFIED_SIGNATURE.dispatch, "retail")
				.catch(() => {})
				.then(data => {
					this.nonVerifiedSignatures = data;
				});
		}
	}
};
</script>
<style scoped>
.rounded-card {
	border-radius: 8px;
}
.float-right {
	position: absolute;
	top: 2px;
	right: 2px;
}
</style>
